/**
 * @description: 需要注册到全局的组件
 */
import { App } from 'vue';

import BaseCascader from './base-cascader/index.vue';
import BaseDownloadButton from './base-download-button/index.vue';
import BasePagination from './base-pagination/index.vue';
import BaseSelect from './base-select/index.vue';
import BaseSvgIcon from './base-svg-icon/index.vue';
import BaseTable from './base-table/index.vue';
import BaseUploadButton from './base-upload-button/index.vue';

import LfScreenForm from './lf-screen-form/src/index.vue';
import LfScreenFormItem from './lf-screen-form-item/src/index.vue';
import LfSteps from './lf-steps/src/index.vue';
import LfReportOperate from './lf-report-operate/src/index.vue';
import LfBaseDialog from './lf-base-dialog/src/index.vue';

export default (app: App): void => {
  app.component('base-pagination', BasePagination);
  app.component('base-table', BaseTable);
  app.component('base-svg-icon', BaseSvgIcon);
  app.component('base-download-button', BaseDownloadButton);
  app.component('base-upload-button', BaseUploadButton);
  app.component('base-select', BaseSelect);
  app.component('base-cascader', BaseCascader);

  app.component('lf-screen-form', LfScreenForm);
  app.component('lf-screen-form-item', LfScreenFormItem);
  app.component('lf-steps', LfSteps);
  app.component('lf-report-operate', LfReportOperate);
  app.component('lf-base-dialog', LfBaseDialog);
};
